import { Link } from 'react-router-dom';
import { colors, gradients, shadows } from '../styles/theme';
import { useAuthStore } from '../stores/authStore';
import { dashboardPathForRole } from '../lib/roleRouting';

const NotFound = (): JSX.Element => {
  const { isAuthenticated, user } = useAuthStore();
  const homePath = isAuthenticated
    ? dashboardPathForRole(user?.role)
    : '/login';
  const homeLabel = isAuthenticated ? 'Back to dashboard' : 'Go to sign in';

  return (
    <div
      className="min-h-screen flex items-center justify-center p-6"
      style={{ background: gradients.navy }}
    >
      <div
        className="w-full max-w-lg rounded-2xl p-10 text-center"
        style={{ background: colors.surface, boxShadow: shadows.card }}
      >
        <div
          className="mx-auto mb-6 w-14 h-14 rounded-2xl flex items-center justify-center font-black text-base"
          style={{ background: gradients.gold, color: colors.navy }}
        >
          404
        </div>

        <h1 className="text-2xl font-bold mb-3" style={{ color: colors.ink }}>
          Page not found
        </h1>
        <p className="text-sm leading-relaxed mb-8" style={{ color: colors.inkSoft }}>
          The address you entered doesn&apos;t match any page in the QMI
          Investor Portal. The link may be outdated, or there might be
          a typo in the URL.
        </p>

        <Link
          to={homePath}
          className="inline-block px-5 py-2.5 rounded-xl text-sm font-semibold transition-all"
          style={{
            background: gradients.gold,
            color: colors.navy,
            boxShadow: shadows.goldCta,
          }}
        >
          {homeLabel}
        </Link>

        <p className="mt-8 text-xs" style={{ color: colors.muted }}>
          Need help?{' '}
          <Link
            to="/contact"
            style={{ color: colors.gold }}
            className="underline underline-offset-2"
          >
            Contact us
          </Link>
        </p>
      </div>
    </div>
  );
};

export default NotFound;
